import { render, staticRenderFns } from "./CompanyVersionCardContent.vue?vue&type=template&id=63b90dc5&"
import script from "./CompanyVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./CompanyVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports